import admin from './locales/ru/admin.json';
import common from './locales/ru/common.json';
import merchant from './locales/ru/merchant.json';
import operator from './locales/ru/operator.json';
import techOperator from './locales/ru/tech-operator.json';
import trader from './locales/ru/trader.json';

export type DefaultRecourse = 'ru';
export const defaultRecourse: DefaultRecourse = 'ru';

export enum TranslationNamespace {
  Common = 'common',
  Admin = 'admin',
  Merchant = 'merchant',
  Operator = 'operator',
  TechOperator = 'tech_operator',
  Trader = 'trader',
}

export const defaultNS = 'common';

// Single source of truth for i18next's `returnNull` option: `i18n.ts` passes this value to
// `i18next.init()` at runtime, and `src/@types/i18next.d.ts` derives `CustomTypeOptions.returnNull`
// from its type. Change it here only — both sides stay in sync automatically.
export const returnNull = false as const;

export const resources = {
  [defaultRecourse]: {
    [TranslationNamespace.Common]: common,
    [TranslationNamespace.Admin]: admin,
    [TranslationNamespace.Merchant]: merchant,
    [TranslationNamespace.Operator]: operator,
    [TranslationNamespace.TechOperator]: techOperator,
    [TranslationNamespace.Trader]: trader,
  },
};
